export default "__VITE_ASSET__BwX9DKsX__"